import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, createBlock as _createBlock, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4 col-sm-6" }
const _hoisted_5 = { class: "form-group mb-4" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "input-error" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-10 col-sm-6" }
const _hoisted_10 = { class: "form-group mb-4" }
const _hoisted_11 = { class: "input-error" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-10 col-sm-6" }
const _hoisted_14 = { class: "form-group mb-4" }
const _hoisted_15 = { class: "input-error" }
const _hoisted_16 = {
  key: 0,
  class: "row"
}
const _hoisted_17 = { class: "col-lg-10 col-sm-6" }
const _hoisted_18 = { class: "form-group mb-4" }
const _hoisted_19 = { class: "input-error" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-lg-10 col-sm-6" }
const _hoisted_22 = { class: "form-group mb-4" }
const _hoisted_23 = { class: "input-error" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-lg-2 col-sm-6" }
const _hoisted_26 = { class: "form-group mb-4" }
const _hoisted_27 = { class: "input-error" }
const _hoisted_28 = { class: "col-lg-2 col-sm-6" }
const _hoisted_29 = { class: "form-group mb-4" }
const _hoisted_30 = { class: "input-error" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-lg-2" }
const _hoisted_33 = { class: "form-group mb-4" }
const _hoisted_34 = { value: null }
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "input-error" }
const _hoisted_37 = {
  key: 0,
  class: "col-lg-12"
}
const _hoisted_38 = { class: "form-group mb-4" }
const _hoisted_39 = { class: "input-error" }
const _hoisted_40 = { class: "form-group mb-4" }
const _hoisted_41 = { class: "input-error" }
const _hoisted_42 = { class: "form-group mb-4" }
const _hoisted_43 = { class: "input-error" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["src"]
const _hoisted_46 = ["src"]
const _hoisted_47 = ["src"]
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-lg-8" }
const _hoisted_51 = {
  key: 0,
  class: "card bg-white border-0 rounded-3 mb-4 mt-4"
}
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-lg-10 col-sm-6" }
const _hoisted_54 = { class: "form-group mb-4" }
const _hoisted_55 = { class: "input-group h-45" }
const _hoisted_56 = { class: "input-error" }
const _hoisted_57 = { class: "input-error" }
const _hoisted_58 = ["onDragstart", "onDrop"]
const _hoisted_59 = { class: "d-flex align-items-center form-check" }
const _hoisted_60 = ["onUpdate:modelValue"]
const _hoisted_61 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_62 = ["onUpdate:modelValue"]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = {
  class: /*@__PURE__*/_normalizeClass(['fs-13 fw-semibold'])
}
const _hoisted_66 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "row" }
const _hoisted_71 = { class: "col-lg-12 mt-4" }
const _hoisted_72 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_73 = ["disabled"]
const _hoisted_74 = { key: 0 }
const _hoisted_75 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_76 = {
  key: 2,
  role: "status"
}
const _hoisted_77 = {
  id: "mdlFileUpload",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlFileUploadLabel",
  "aria-hidden": "true",
  size: "large"
}
const _hoisted_78 = { class: "modal-dialog modal-md" }
const _hoisted_79 = { class: "modal-content" }
const _hoisted_80 = { class: "modal-body" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-lg-8" }
const _hoisted_83 = {
  key: 0,
  class: "form-group mb-4"
}
const _hoisted_84 = { value: null }
const _hoisted_85 = ["value"]
const _hoisted_86 = ["value"]
const _hoisted_87 = { class: "input-error" }
const _hoisted_88 = { class: "row" }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = ["src"]
const _hoisted_92 = ["src"]
const _hoisted_93 = { class: "col-lg-5" }
const _hoisted_94 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_FilePond = _resolveComponent("FilePond")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[29] || (_cache[29] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm_Question && _ctx.validateForm_Question(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[35] || (_cache[35] = _createElementVNode("label", { class: "label text-secondary" }, "Tipo de Pregunta", -1 /* HOISTED */)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-control h-45",
                  "aria-label": "Default select example",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.question.questionTypeId) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearError('questionTypeId')))
                }, [
                  _cache[34] || (_cache[34] = _createElementVNode("option", { value: null }, "-- Seleccionar --", -1 /* HOISTED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsQuestionTypes, (item, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: item.id,
                      key: i
                    }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_6))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelSelect, _ctx.question.questionTypeId]
                ]),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.errors.questionTypeId), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[36] || (_cache[36] = _createElementVNode("label", { class: "label text-secondary" }, "Enunciado de la Pregunta", -1 /* HOISTED */)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control h-45",
                  placeholder: "Ingresar el enunciado de la pregunta",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.question.sentence) = $event)),
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearError('sentence')))
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelText, _ctx.question.sentence]
                ]),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.errors.sentence), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[37] || (_cache[37] = _createElementVNode("label", { class: "label text-secondary" }, "Descripción", -1 /* HOISTED */)),
                _createVNode(_component_TextEditor, {
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearError('description'))),
                  class: "text-editor",
                  modelValue: _ctx.question.description,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.question.description) = $event)),
                  placeholder: 'Ingrese el contenido'
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.errors.description), 1 /* TEXT */)
              ])
            ])
          ]),
          (_ctx.question.questionTypeId == _ctx.QUESTION_TYPE.SEMIOPEN)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "label text-secondary" }, "Respuesta", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control h-45",
                      placeholder: "Ingresar la respuesta correcta",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.question.answer) = $event)),
                      onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearError('answer')))
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelText, _ctx.question.answer]
                    ]),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.errors.answer), 1 /* TEXT */)
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[39] || (_cache[39] = _createElementVNode("label", { class: "label text-secondary" }, "Pista", -1 /* HOISTED */)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control h-45",
                  placeholder: "Ingresar una pista",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.question.hint) = $event)),
                  onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearError('hint')))
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelText, _ctx.question.hint]
                ]),
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.errors.hint), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _cache[40] || (_cache[40] = _createElementVNode("label", { class: "label text-secondary" }, "Reintentos", -1 /* HOISTED */)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control h-45",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.question.retries) = $event)),
                  onInput: _cache[11] || (_cache[11] = ($event: any) => {
                  _ctx.handleQuestionInput($event, 'retries');
                  _ctx.clearError('retries');
                }),
                  maxlength: "2"
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelText, _ctx.question.retries]
                ]),
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.errors.retries), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _cache[41] || (_cache[41] = _createElementVNode("label", { class: "label text-secondary" }, "Puntos bonus", -1 /* HOISTED */)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control h-45",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.question.bonusPoints) = $event)),
                  onInput: _cache[13] || (_cache[13] = ($event: any) => {
                  _ctx.handleQuestionInput($event, 'bonusPoints');
                  _ctx.clearError('bonusPoints');
                }),
                  maxlength: "3"
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelText, _ctx.question.bonusPoints]
                ]),
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.errors.bonusPoints), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[42] || (_cache[42] = _createElementVNode("label", { class: "label text-secondary strong" }, "Tipo de Multimedia", -1 /* HOISTED */)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.question.multimediaTypeId) = $event)),
                  onChange: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (
                  _ctx.setMultimediaTypeContent(_ctx.question.multimediaTypeId)
                ), ["prevent"])),
                  class: "form-select form-control h-45",
                  "aria-label": "Default select example"
                }, [
                  _createElementVNode("option", _hoisted_34, _toDisplayString(_ctx.LABELS.SELECT), 1 /* TEXT */),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.multimediaOptions, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_35))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelSelect, _ctx.question.multimediaTypeId]
                ]),
                _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.errors.multimediaTypeId), 1 /* TEXT */)
              ])
            ]),
            (_ctx.question.multimediaTypeId != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _cache[43] || (_cache[43] = _createElementVNode("label", { class: "label text-secondary" }, "Multimedia", -1 /* HOISTED */)),
                    (!_ctx.question.urlMultimedia)
                      ? _withDirectives((_openBlock(), _createBlock(_component_FilePond, {
                          key: 0,
                          ref: "filePondRefQuestion",
                          style: {"margin-bottom":"-12px important!"},
                          name: "fileMultimedia",
                          maxFileSize: '2MB',
                          "accepted-file-types": _ctx.supportedFormats,
                          "allow-multiple": "false",
                          "max-files": 1,
                          "label-idle": "Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>",
                          labelMaxFileSizeExceeded: 'El archivo es demasiado grande',
                          labelMaxFileSize: 'El tamaño máximo permitido es {filesize}',
                          labelFileTypeNotAllowed: 'El archivo tiene una extensión no permitida',
                          fileValidateTypeLabelExpectedTypes: `Los tipos de archivo permitidos son: ${_ctx.supportedFormats.join(
                  ', '
                )}`,
                          credits: "",
                          onUpdatefiles: _ctx.handleUpdateFiles,
                          onRemovefile: _ctx.handleRemoveFile,
                          onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.clearError('fileMultimedia')))
                        }, null, 8 /* PROPS */, ["accepted-file-types", "fileValidateTypeLabelExpectedTypes", "onUpdatefiles", "onRemovefile"])), [
                          [_vShow, _ctx.question.multimediaTypeId != _ctx.MULTIMEDIA_TYPES.LINK]
                        ])
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.errors.fileMultimedia), 1 /* TEXT */)
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_40, [
                      _cache[44] || (_cache[44] = _createElementVNode("label", { class: "label text-secondary" }, "Link", -1 /* HOISTED */)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control h-45",
                        placeholder: "Ingrese el link",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.question.link) = $event)),
                        onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.clearError('link')))
                      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelText, _ctx.question.link]
                      ]),
                      _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.errors.link), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _cache[45] || (_cache[45] = _createElementVNode("label", { class: "label text-secondary" }, "Texto del Link", -1 /* HOISTED */)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control h-45",
                        placeholder: "Ingrese el texto del link",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.question.steps) = $event)),
                        onInput: _cache[20] || (_cache[20] = ($event: any) => (_ctx.clearError('steps')))
                      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelText, _ctx.question.steps]
                      ]),
                      _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.errors.steps), 1 /* TEXT */)
                    ])
                  ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.question.multimediaTypeId == _ctx.MULTIMEDIA_TYPES.LINK]
                  ]),
                  _createElementVNode("div", null, [
                    (
                  _ctx.question.urlMultimedia &&
                  _ctx.question.multimediaTypeId == _ctx.MULTIMEDIA_TYPES.IMAGE
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("img", {
                            src: _ctx.question.urlMultimedia,
                            alt: "Multimedia",
                            class: "img-fluid mb-2 d-block"
                          }, null, 8 /* PROPS */, _hoisted_45)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.videoBlobUrlQuestion)
                      ? (_openBlock(), _createElementBlock("video", {
                          key: 1,
                          src: _ctx.videoBlobUrlQuestion,
                          controls: "",
                          width: "270"
                        }, null, 8 /* PROPS */, _hoisted_46))
                      : _createCommentVNode("v-if", true),
                    (_ctx.audioUrlQuestion)
                      ? (_openBlock(), _createElementBlock("audio", {
                          key: 2,
                          src: _ctx.audioUrlQuestion,
                          controls: "",
                          style: {"margin-top":"1rem"}
                        }, null, 8 /* PROPS */, _hoisted_47))
                      : _createCommentVNode("v-if", true),
                    (_ctx.pdfUrlQuestion)
                      ? (_openBlock(), _createElementBlock("iframe", {
                          key: 3,
                          src: _ctx.pdfUrlQuestion,
                          width: "100%",
                          height: "700px"
                        }, null, 8 /* PROPS */, _hoisted_48))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeMultimediaFile && _ctx.removeMultimediaFile(...args)), ["prevent"])),
                    class: "btn btn-danger"
                  }, " Eliminar multimedia ")
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              (_ctx.question.questionTypeId == _ctx.QUESTION_TYPE.CLOSED)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _cache[51] || (_cache[51] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Respuestas", -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _withDirectives(_createElementVNode("input", {
                              maxlength: "5000",
                              ref: "questionInput",
                              type: "text",
                              class: "form-control",
                              placeholder: "Ingresar la respuesta",
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.questionOptionText) = $event)),
                              onKeydown: _cache[23] || (_cache[23] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.addQuestionOption && _ctx.addQuestionOption(...args)), ["prevent"]), ["enter"]))
                            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                              [_vModelText, _ctx.questionOptionText]
                            ]),
                            _createElementVNode("button", {
                              class: "btn btn-primary",
                              type: "button",
                              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.addQuestionOption && _ctx.addQuestionOption(...args)))
                            }, " Agregar ")
                          ]),
                          _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.errors.questionOptionText), 1 /* TEXT */)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.errors.questionOptions), 1 /* TEXT */),
                    _createElementVNode("ul", {
                      class: "ps-0 mb-0 list-unstyled o-sortable cursor-move list-group",
                      onDragover: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["prevent"])),
                      onDrop: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionOptions, (drag, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: drag.id,
                          onDragstart: ($event: any) => (_ctx.dragStart(index)),
                          onDragend: _cache[25] || (_cache[25] = ($event: any) => (_ctx.dragEnd())),
                          onDragover: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["prevent"])),
                          onDrop: ($event: any) => (_ctx.dragDrop(index)),
                          draggable: "true",
                          class: _normalizeClass([
                    'p-2 ps-3 rounded-2  d-flex align-items-center justify-content-between list-group-item list-group-item-primary bg-transparent text-primary',
                  ])
                        }, [
                          _createCommentVNode(" LEFT SIDE "),
                          _createElementVNode("div", _hoisted_59, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((drag.isCorrect) = $event),
                              class: "form-check-input me-3 mt-0"
                            }, null, 8 /* PROPS */, _hoisted_60), [
                              [_vModelCheckbox, drag.isCorrect]
                            ]),
                            _createCommentVNode(" Inline edit "),
                            (drag.isEditing)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((drag.option) = $event),
                                    class: "form-control form-control-sm h-45 me-2",
                                    style: {"width":"710px","height":"36px"}
                                  }, null, 8 /* PROPS */, _hoisted_62), [
                                    [_vModelText, drag.option]
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-success text-success bg-transparent me-1 pb-0",
                                    onClick: ($event: any) => (_ctx.saveOption(index)),
                                    title: "Guardar"
                                  }, [...(_cache[46] || (_cache[46] = [
                                    _createElementVNode("span", { class: "material-symbols-outlined fw-bold" }, "check", -1 /* HOISTED */)
                                  ]))], 8 /* PROPS */, _hoisted_63),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-danger text-danger bg-transparent pb-0",
                                    onClick: ($event: any) => (_ctx.cancelEdit(index)),
                                    title: "Cancelar"
                                  }, [...(_cache[47] || (_cache[47] = [
                                    _createElementVNode("span", { class: "material-symbols-outlined fw-bold" }, "close", -1 /* HOISTED */)
                                  ]))], 8 /* PROPS */, _hoisted_64)
                                ]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createCommentVNode(" Normal view "),
                                  _createElementVNode("span", _hoisted_65, _toDisplayString(drag.option), 1 /* TEXT */)
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                          ]),
                          _createCommentVNode(" RIGHT SIDE: Buttons "),
                          (!drag.isEditing)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(["btn btn-sm btn-default", {
                        'text-success': drag.multimediaTypeId != null,
                        'text-primary': drag.multimediaTypeId == null,
                      }]),
                                  onClick: ($event: any) => (_ctx.editFile(index)),
                                  title: "Agregar multimedia"
                                }, [...(_cache[48] || (_cache[48] = [
                                  _createElementVNode("span", { class: "material-symbols-outlined menu-icon me-0" }, "music_note_add", -1 /* HOISTED */)
                                ]))], 10 /* CLASS, PROPS */, _hoisted_67),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm btn-default text-primary",
                                  onClick: ($event: any) => (_ctx.editOption(index)),
                                  title: "Editar"
                                }, [...(_cache[49] || (_cache[49] = [
                                  _createElementVNode("span", { class: "material-symbols-outlined menu-icon me-0" }, "edit", -1 /* HOISTED */)
                                ]))], 8 /* PROPS */, _hoisted_68),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm btn-default text-primary",
                                  onClick: ($event: any) => (_ctx.removeQuestionOption(index)),
                                  title: "Eliminar"
                                }, [...(_cache[50] || (_cache[50] = [
                                  _createElementVNode("span", { class: "material-symbols-outlined menu-icon me-0" }, "delete", -1 /* HOISTED */)
                                ]))], 8 /* PROPS */, _hoisted_69)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_58))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 32 /* NEED_HYDRATION */)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createVNode(_component_RouterLink, { to: `/questions` }, {
                  default: _withCtx(() => _cache[52] || (_cache[52] = [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                    }, " Cancelar ", -1 /* HOISTED */)
                  ])),
                  _: 1 /* STABLE */
                }),
                _createElementVNode("button", {
                  class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4",
                  type: "submit",
                  disabled: _ctx.isLoading
                }, [
                  (!_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(_ctx.question.id == 0 ? "Crear Pregunta" : "Actualizar Pregunta"), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_75))
                    : _createCommentVNode("v-if", true),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_76, "Procesando..."))
                    : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, _hoisted_73)
              ])
            ])
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_77, [
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("div", _hoisted_79, [
          _cache[54] || (_cache[54] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: "mdlFileUploadLabel"
            }, " Jugada - Archivo "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                (_ctx.questionOptionEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      _cache[53] || (_cache[53] = _createElementVNode("label", { class: "label text-secondary strong" }, "Tipo de Multimedia", -1 /* HOISTED */)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.questionOptionEdit.multimediaTypeId) = $event)),
                        onChange: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (
                    _ctx.setMultimediaTypeQuestionOptionContent(
                      _ctx.questionOptionEdit.multimediaTypeId
                    )
                  ), ["prevent"])),
                        class: "form-select form-control h-45",
                        "aria-label": "Default select example"
                      }, [
                        _createElementVNode("option", _hoisted_84, _toDisplayString(_ctx.LABELS.SELECT), 1 /* TEXT */),
                        _createElementVNode("option", {
                          value: _ctx.MULTIMEDIA_TYPES.IMAGE
                        }, _toDisplayString(_ctx.multimediaOptions[_ctx.MULTIMEDIA_TYPES.IMAGE - 1].label), 9 /* TEXT, PROPS */, _hoisted_85),
                        _createElementVNode("option", {
                          value: _ctx.MULTIMEDIA_TYPES.AUDIO
                        }, _toDisplayString(_ctx.multimediaOptions[_ctx.MULTIMEDIA_TYPES.AUDIO - 1].label), 9 /* TEXT, PROPS */, _hoisted_86)
                      ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelSelect, _ctx.questionOptionEdit.multimediaTypeId]
                      ]),
                      _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.errors.multimediaTypeId), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              (!_ctx.questionOptionEdit?.urlMultimediaBlob)
                ? (_openBlock(), _createBlock(_component_FilePond, {
                    key: 0,
                    ref: "filePondRefAction",
                    name: "multimedia",
                    maxFileSize: '2MB',
                    "accepted-file-types": _ctx.supportedFormatsModal,
                    "allow-multiple": "false",
                    "max-files": 1,
                    "label-idle": "Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>",
                    labelMaxFileSizeExceeded: 'El archivo es demasiado grande',
                    labelMaxFileSize: 'El tamaño máximo permitido es {filesize}',
                    labelFileTypeNotAllowed: 'El archivo tiene una extensión no permitida',
                    fileValidateTypeLabelExpectedTypes: `Los tipos de archivo permitidos son: ${_ctx.supportedFormatsModal.join(
                ', '
              )}`,
                    credits: "",
                    onRemovefile: _ctx.handleRemoveFileModal
                  }, null, 8 /* PROPS */, ["accepted-file-types", "fileValidateTypeLabelExpectedTypes", "onRemovefile"]))
                : _createCommentVNode("v-if", true),
              (_ctx.questionOptionEdit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                    (
                  _ctx.questionOptionEdit.multimediaTypeId ==
                    _ctx.MULTIMEDIA_TYPES.IMAGE &&
                  _ctx.questionOptionEdit?.urlMultimediaBlob
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                          _createElementVNode("img", {
                            src: _ctx.questionOptionEdit?.urlMultimediaBlob,
                            alt: "Multimedia",
                            class: "img-fluid mb-2 d-block",
                            style: {"width":"50%"}
                          }, null, 8 /* PROPS */, _hoisted_91)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (
                  _ctx.questionOptionEdit.multimediaTypeId ==
                    _ctx.MULTIMEDIA_TYPES.AUDIO &&
                  _ctx.questionOptionEdit?.urlMultimediaBlob
                )
                      ? (_openBlock(), _createElementBlock("audio", {
                          key: 1,
                          src: _ctx.questionOptionEdit?.urlMultimediaBlob,
                          controls: "",
                          style: {"margin-top":"1rem"}
                        }, null, 8 /* PROPS */, _hoisted_92))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_93, [
                (_ctx.questionOptionEdit?.urlMultimediaBlob)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[32] || (_cache[32] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeMultimediaFileModal && _ctx.removeMultimediaFileModal(...args)), ["prevent"])),
                      class: "btn btn-danger"
                    }, " Eliminar multimedia "))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.closeModalFile && _ctx.closeModalFile(...args)))
            }, " Guardar ")
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}